export default function QuoteMark() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.1429 0L21.4286 22.0678V42H0V22.0678L15.5714 0H27.1429ZM60 0L54.2857 22.0678V42H32.8571V22.0678L48.5714 0H60Z" fill="#1C5DCC" />
        </svg>
    )
}